import comp from "./ManageTagsModal";
export default comp;
